import Page from "@/lib/components/Page";
import Markdown from "react-native-marked";
import {markdownStyle, markdownTheme} from "@/lib/globstyles";
import {Color} from "@/lib/styles";
import {ReactNode} from "react";

type MarkdownPageProps = {
    markdown: string;
    children?: ReactNode,
}

export default function MarkdownPage({markdown, children}: MarkdownPageProps) {
    return (
        <Page scrollable={true}>
            <Markdown
                value={markdown}
                styles={markdownStyle}
                theme={markdownTheme}
                flatListProps={{
                    scrollEnabled: false,
                    style: {
                        backgroundColor: Color.Background,
                    },
                }}
            />
            {children}
        </Page>
    )
}